import { useForm } from "react-hook-form";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { ObraAreaChecklistDropDown } from "../../../../domain/models/obra_area_checklist_dropdown";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { IncluirObraAreaServicosForm, IncluirObraAreaServicosSchema } from "../../../schemas/Obras_cadastroarea/incluir_obra_area_servicos";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { ChecklistServicoDropDown } from "../../../../domain/models/checklist_servico_dropdown";

import FormContainer from "../../../../../../common/components/form_container";

/**
 * IncluirChecklistAreaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  areas: ObraAreaChecklistDropDown[],
  checklists: ChecklistServicoDropDown[],
  onClose: () => void;
  onSubmit: (form: IncluirObraAreaServicosForm) => void;
  onSelectedAreasChange: (areas: number[] | string[] | null) => void;
};

export const IncluirChecklistAreaModal = ({
  open,
  saving,
  loading,
  areas,
  checklists,
  onClose,
  onSubmit,
  onSelectedAreasChange,
}: Props) => {
  const hookForm = useForm<IncluirObraAreaServicosForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(IncluirObraAreaServicosSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Incluir Checklist de área'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormMultiAutocomplete
            name='areas'
            label='Área'
            options={areas}
            getOptionKey={x => x.idObraAreaChecklist}
            getOptionLabel={x => x.descricao ?? ''}
            reactHookForm={hookForm}
            onClose={onSelectedAreasChange}
          />

          <DefaultFormMultiAutocomplete
            name='checklists'
            label='Checklist'
            options={checklists}
            getOptionKey={x => x.idChecklistServico}
            getOptionLabel={x => x.descricao ?? ''}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}